import React from 'react';
import { GoogleLogin } from 'react-google-login';

// https://medium.com/@amaancr7777/step-by-step-guide-integrating-google-authentication-in-react-js-fbf9c4ce358f

const GoogleAuth = ({ onSuccess, onFailure }) => {
  const clientId = "506419675854-3c20iq6hid7r1gtsej8u3k29pnke5hg4.apps.googleusercontent.com"; // Replace with your actual Google client ID

  const handleSuccess = (response) => {
    console.log('Google login successful:', response);
    window.location.replace('/account');
    onSuccess(response);
  };

  const handleFailure = (error) => {
    console.error('Google login failed:', error);
    onFailure(error);
  };

  return (
    <GoogleLogin
      clientId={clientId}
      buttonText="Login with Google"
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      cookiePolicy={'single_host_origin'}
    />
  );
};

export default GoogleAuth;